export const requestNotificationPermission = async () => {
    if (!("Notification" in window)) {
        console.log("Browser does not support notifications");
        return;
    }

    if (Notification.permission !== "granted") {
        const permission = await Notification.requestPermission();

        console.log("Notification permission:", permission);
    }
};

export const showBrowserNotification = ({
    title,
    body,
    icon,
}) => {
    if (!("Notification" in window)) return;

    if (Notification.permission === "granted") {

        const notification = new Notification(title, {
            body,
            icon,
        });

        notification.onclick = () => {
            window.focus();

            // Optional:
            notification.close();
        };
    }
};